import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { apis } from 'apis/apis';

///////////////////////////////wconcepts
export const useGetDashboardGroups = () => {
	return useQuery({
		queryKey: ['groups'],
		queryFn: () => apis.getDashboardGroups(),
		retry: 0,
		enabled: true,
		staleTime: 3600000,
		gcTime: Infinity,
	});
};

export const useGetDashboardGroupSummary = (groupId: string) => {
	return useQuery({
		queryKey: ['group', groupId],
		queryFn: () => {
			return apis.getDashboardGroupSummary(groupId);
		},
		retry: 0,
		enabled: groupId !== null,
		staleTime: 3600000,
		gcTime: Infinity,
	});
};

export const useGetCreatorRankings = (
	groupId?: string | null,
	orderBy?: string,
	enabled?: boolean,
) => {
	return useQuery({
		queryKey: ['creator-rankings', groupId, orderBy],
		queryFn: () => {
			if (groupId === null || groupId === undefined) {
				return [];
			}
			return apis.getCreatorRankings(groupId, orderBy ?? '');
		},
		enabled: enabled && groupId !== null,
		retry: 0,
		staleTime: 3600000,
		gcTime: Infinity,
	});
};

export const useGetMissionRainkings = (
	groupId: string,
	missionNumber: string,
	orderBy?: string,
	enabled?: boolean,
) => {
	return useQuery({
		queryKey: ['mission-rankings', groupId, missionNumber, orderBy],
		queryFn: () => apis.getMissionRankings(groupId, missionNumber, orderBy ?? ''),
		retry: 0,
		staleTime: 3600000,
		gcTime: Infinity,
		enabled: enabled && groupId !== null && missionNumber !== undefined,
	});
};

export const useGetMissionPerformance = (groupId?: string, missionNumber?: string) => {
	return useQuery({
		queryKey: ['mission-performance', groupId, missionNumber],
		queryFn: () => apis.getMissionPerformance(groupId, missionNumber),
		retry: 0,
		staleTime: 3600000,
		gcTime: Infinity,
		enabled: groupId !== null && missionNumber !== undefined,
	});
};
//getGroupPerformances
export const useGetGroupPerformances = (groupId?: string) => {
	return useQuery({
		queryKey: ['group-performances', groupId],
		queryFn: () => apis.getGroupPerformances(groupId),
		retry: 0,
		staleTime: 3600000,
		gcTime: Infinity,
		enabled: groupId !== null,
	});
};

//GET /api/groups/{groupId}/insights
export const useGetGroupInsights = (groupId: string) => {
	return useQuery({
		queryKey: ['group-insights', groupId],
		queryFn: () => apis.getGroupInsights(groupId),
		retry: 0,
		staleTime: 3600000,
		gcTime: 0, // gcTime을 0으로 설정하여 캐시를 즉시 삭제 - Donut Chart Total 값이 재렌더링되지 않음
		enabled: groupId !== null,
	});
};

////////////////////////////////////////////////////////
